export default {
    SET_ORDER_INFO: 'SET_ORDER_INFO',
    SET_ITEM_IDS: 'SET_ITEM_IDS',
    RESET: 'RESET',
    TEST_ITEM_PACKAGE_LIST: 'TEST_ITEM_PACKAGE_LIST',
    TEST_ITEM_TYPE_LIST: 'TEST_ITEM_TYPE_LIST',
    SET_TEST_ITEM_TYPE_ITEM: 'SET_TEST_ITEM_TYPE_ITEM',
    SET_TEST_ITEM: 'SET_TEST_ITEM',
    SET_TEST_ITEM_PACKAGE_ITEM: 'SET_TEST_ITEM_PACKAGE_ITEM',
    SELECT_TEST_ITEM: 'SELECT_TEST_ITEM'
}


// WEBPACK FOOTER //
// ./src/_store/modules/itemModule/mutation-enum.js